import React, { useState, useEffect } from "react";
import { Box, Button, Modal, Typography, Grid } from "@mui/material";

const LeaveWithoutSavingModal = ({ isOpen, handleClose, handleLeave }) => {
  const [headerText, setHeaderText] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");

  useEffect(() => {
    setHeaderText("Leave without saving?");

    if (window.location.pathname.includes("/add_new_assignment")) {
      setHeaderText("Leave without setting this assignment?");
      setSubject("assignment");
    }

    if (window.location.pathname.includes("/add-activity")) {
      setSubject("activity");
    }

    if (
      window.location.pathname.includes("/add-client") ||
      window.location.pathname.includes("/client_")
    ) {
      setSubject("client");
    }

    if (
      window.location.pathname.includes("/add-caregiver") ||
      window.location.pathname.includes("/caregiver_")
    ) {
      setSubject("caregiver");
    }

    if (window.location.pathname.includes("/add-admin")) {
      setSubject("admin");
    }

    setMessage(
      `You'll lose any progress you made${
        subject ? " on this " + subject : ""
      }.`,
    );
  });

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="delete-activity-modal"
      aria-describedby="delete-activity-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          boxShadow: 24,
          borderRadius: 2,
          backgroundColor: "#d0d0d0",
          p: 3,
          color: "#000000",
        }}
      >
        <Typography
          id="delete-activity-modal"
          variant="h4"
          mb={6}
          sx={{ color: "#000000" }}
        >
          {headerText}
        </Typography>
        <Typography
          id="delete-activity-modal"
          variant="h6"
          mb={6}
          sx={{ color: "#000000" }}
        >
          {message}
        </Typography>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item>
            <Button
              variant="outlined"
              className="activity-action-btn"
              onClick={handleClose}
            >
              <Typography textTransform={"capitalize"}> Go Back </Typography>
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="error" onClick={handleLeave}>
              <Typography textTransform={"capitalize"}>Leave</Typography>
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
export default LeaveWithoutSavingModal;
